var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"history-content"},[_c('div',{staticClass:"search-wrap"},[_vm._v(" 111 ")])])}]

export { render, staticRenderFns }